import React from 'react'
import { Section } from '@shared/components/section'
import { Button } from '@shared/componentsStyled/Button'
import styled from 'styled-components'

export const BlockTextCols = ({
	blockTitle,
	buttonTitle,
	data,
	description,
	onButtonClick,
}: BlockTextColsProps): JSX.Element => {
	return (
		<Section>
			<ViewRoot>
				{!!blockTitle && <TextTitle>{blockTitle}</TextTitle>}
				{!!description && <TextDescription>{description}</TextDescription>}
				{!!data?.length && (
					<Grid>
						{data.map((item, idx) => (
							<Cell key={idx}>
								<TextItemTitle>{item.title ? item.title : <>&nbsp;</>}</TextItemTitle>
								<TextItem>{item.text}</TextItem>
							</Cell>
						))}
					</Grid>
				)}
				{!!onButtonClick && !!buttonTitle && (
					<ViewButton>
						<Button type='button' onClick={onButtonClick}>
							{buttonTitle}
						</Button>
					</ViewButton>
				)}
			</ViewRoot>
		</Section>
	)
}

const ViewButton = styled.div(({ theme }) => ({
	marginTop: 40,
	'& button': {
		width: '100%',
	},
	[theme.mediaQueries.mediaMinWidthMobile]: {
		'& button': {
			width: 'auto',
		},
	},
}))

const TextItem = styled.p(({ theme }) => ({
	whiteSpace: 'pre-wrap',
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))

const TextItemTitle = styled.h3(({ theme }) => ({
	marginBottom: 20,
	...theme.typography.header18_24,
}))

const Cell = styled.div(({ theme }) => ({
	flex: 1,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		flex: 'calc(50% - 16px)',
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		flex: '283px',
		flexGrow: 0,
	},
}))

const Grid = styled.div(({ theme }) => ({
	display: 'flex',
	gap: '40px 32px',
	justifyContent: 'space-between',
	flexWrap: 'wrap',
	flexDirection: 'column',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		flexDirection: 'row',
	},
}))

const TextDescription = styled.h3(({ theme }) => ({
	marginBottom: 40,
	...theme.typography.header18_24,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header24_32,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	marginBottom: 20,
	...theme.typography.header24_28,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header40_44,
	},
}))

const ViewRoot = styled.div({
	marginBottom: 60,
})

interface TextColItem {
	title?: string | undefined
	text?: string | undefined
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BlockTextColsData extends Array<TextColItem> {}

interface BlockTextColsProps {
	blockTitle?: string | undefined
	buttonTitle?: string | undefined
	description?: string | undefined
	data?: BlockTextColsData
	onButtonClick?(): void
}
